import React, { useCallback } from 'react';
import Layout from '../../components/layout/Layout';
import Card from '../../components/card/Card';
import Table from '../../components/table/Table';
import {WSREST_TABATA} from '../../config';
import { useParams } from 'react-router-dom';
import RigaOrdine from '../../components/table/RigaOrdine';
import CardInfoOrdini from '../../components/card/CardInfoOrdine';
import CardInfoIndirizzo from '../../components/card/CardInfoIndirizzo';
import { getMerlinoT } from '../../services/merlinoService';

function DettaglioOrdine() {
    const { idordine } = useParams();
    const tableHeader = ["Numero Riga", "Codice prodotto", "Descrizione", "Quantità", "Prezzo", "Sconto", "Prezzo Scontato", "Importo con Iva"];

    const fetchData = useCallback(async () => {
        const url = WSREST_TABATA;
        const token = getMerlinoT();
        const payload = { idordine };

        try {
            const response = await fetch(`${url}ordertabb2c/getRigheOrdine`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                return await response.json();
            } else {
                console.error("Errore nella risposta:", response.status);
                return [];
            }
        } catch (error) {
            console.error("Errore durante la fetch:", error);
            return [];
        }
    }, [idordine]);
    

    return (
        <>
            <div className="row">
                 <div className='col-md-6'>
                     <CardInfoIndirizzo idordine={idordine}/>
                 </div>
                  <div className='col-md-6'>
                     <CardInfoOrdini idordine={idordine}/>
                 </div>
            </div>

            <Card titoloCard={`Dettaglio ordine ${idordine}`}>
                <Table ComponentDaRenderizzare={RigaOrdine} fetchData={fetchData} tableHeader={tableHeader} />
            </Card>
        </>
    );
}

export default DettaglioOrdine;
